import React from 'react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Region } from '@/types'

interface BranchSelectProps {
  branches: string[]
  selectedBranch: string
  setSelectedBranch: (branch: string) => void
}

const REGIONS = JSON.parse(
  sessionStorage.getItem('regions') ?? '[]'
) as Region[]

const BranchSelect: React.FC<BranchSelectProps> = ({
  branches,
  selectedBranch,
  setSelectedBranch,
}) => {
  return (
    <div className="h-8 w-[200px]">
      <Select
        value={selectedBranch}
        onValueChange={(value) => setSelectedBranch(value)}
      >
        <SelectTrigger className="h-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="w-[200px]">
          {REGIONS.map((region, index) => (
            <React.Fragment key={`region-${region.id}`}>
              <SelectItem
                value={branches.slice(index * 2, index * 2 + 2).join(',')}
              >
                {region.name}
              </SelectItem>
              {region.branches.map((branch) => (
                <SelectItem
                  key={`branch-${branch.id}`}
                  value={branch.name}
                  className="ml-4"
                >
                  {branch.name}
                </SelectItem>
              ))}
            </React.Fragment>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export { BranchSelect }
